module.exports = __webpack_public_path__ + "img/grid-stack.ed9b771e.svg";